import * as React from "react";
import { AudioVideoProps, AudioVideoDefaultProps, Box, UserContextType, WithToast, withToast, Button, Loader, MORE_SVG, UserContextConsumer } from 'bpm-web-generic';
import { RouteComponentProps, withRouter } from "react-router";
import { MediaAPI, User, errorToString, } from "bpm-client-api";
import * as Hls from "hls.js";
import * as SocketIOClient from "socket.io-client";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import Input from "reactstrap/lib/Input";
import { PROFILE_PICTURE_RED, VERIFIED_BLUE_SVG, EYE_SVG, SHARE_SVG } from "src/assets";
import autoscroll from 'autoscroll-react'
import { VOD } from "bpm-client-api/lib/endpoints/media";
import YouTube from 'react-youtube';
import { BrowseDropDown } from "src/components/BrowseDropDown";
import { Analytics } from "src/manager/AnalyticsManager";
import { shareVod } from "src/manager/ShareManager";
import Picker from 'emoji-picker-react';
import * as H from 'history'
import { displayDate } from "bpm-web-generic";
export interface LiveProps extends AudioVideoDefaultProps, AudioVideoProps, RouteComponentProps, WithToast {
    onLoading: (loading: boolean) => void
    maxHeight?: number
    useLiveInline?: boolean
}
interface Message {
    id: string
    message: string
    color: string;
    picture: string;
    admin: boolean;
    time: string
    from: string
}
class LiveInner extends React.Component<LiveProps, {
    loading: boolean
    streaming: boolean
    viewCount: number

    vod?: VOD[]
    currentVOD?: VOD

    videoHeight?: number

    liveTitle?: string
}> {

    context: User
    private videoContainerDiv: HTMLDivElement;
    private _videoSubTitleContainer: HTMLDivElement;
    private titleContainer: HTMLDivElement | null;
    get videoSubTitleContainer() {
        return this._videoSubTitleContainer
    }
    set videoSubTitleContainer(value: HTMLDivElement) {
        this._videoSubTitleContainer = value
        if (this.videoContainerDiv) {
            this.setStyle(this.videoContainerDiv)
        }
    }

    private reloadTimer: NodeJS.Timeout;
    private hls: Hls;
    private lastSrc: string;
    private resizeTimer: NodeJS.Timeout;


    constructor(props: LiveProps) {
        super(props);

        this.state = {
            loading: true,
            streaming: false,
            viewCount: 0,
        }
        this.onResize = this.onResize.bind(this)
        this.onVideoEnded = this.onVideoEnded.bind(this)
    }

    componentDidMount() {
        this.load()
        window.addEventListener('resize', this.onResize)
    }

    componentWillUnmount() {
        this.resetStyle()
        this.reloadTimer && clearTimeout(this.reloadTimer)
        window.removeEventListener('resize', this.onResize)
        this.resizeTimer && clearTimeout(this.resizeTimer)
    }

    onViewerCountChange = (viewerCount: number) => {
        this.setState({ viewCount: viewerCount })
    }


    setStyle(ref: HTMLDivElement) {
        if (!this.videoSubTitleContainer) {
            return
        }
        this.videoSubTitleContainer.style.maxWidth = `${ref.clientWidth}px`

        const videoElem = document.getElementById('bpmlive')! as HTMLVideoElement
        const offset = ref.getBoundingClientRect() as DOMRect
        if (this.titleContainer)
            this.titleContainer.style.marginLeft = `${offset.left - 40}px`
        videoElem.style.position = 'absolute'
        videoElem.style.top = `${offset.top}px`
        videoElem.style.left = `${offset.left}px`
        videoElem.style.height = `${offset.height}px`
        videoElem.style.width = `${offset.width}px`
        videoElem.style.visibility = 'visible'
        if (this.state.videoHeight != ref.clientHeight) {
            this.setState({ videoHeight: ref.clientHeight })
        }
    }

    onVideoEnded() {
        this.load().removeEventListener('ended', this.onVideoEnded)
    }

    resetStyle() {
        if (this.videoSubTitleContainer)
            this.videoSubTitleContainer.style.maxWidth = ''
        if (this.titleContainer)
            this.titleContainer.style.marginLeft = ``
        const videoElem = document.getElementById('bpmlive')! as HTMLVideoElement
        videoElem.style.top = '0px'
        videoElem.style.left = '0px'
        videoElem.style.height = '0px'
        videoElem.style.width = '0px'
        videoElem.style.visibility = 'hidden'
        videoElem.removeEventListener('ended', this.onVideoEnded)
    }

    initHLS(src: string, video: HTMLVideoElement, live: boolean) {
        this.lastSrc = src
        if (video.canPlayType('application/vnd.apple.mpegurl') || !live) {
            video.src = src
            video.play();
        } else if (Hls.isSupported()) {
            if (this.hls) {
                this.hls.destroy()
            }
            this.hls = new Hls();
            this.hls.loadSource(src);
            this.hls.attachMedia(video);
            this.hls.on(Hls.Events.MANIFEST_PARSED, function () {
                video.play();
            });
        }
    }

    load(showLoading: boolean = true) {
        this.props.onLoading(showLoading)
        const videoElem = document.getElementById('bpmlive')! as HTMLVideoElement
        if (videoElem.src && videoElem.playbackRate == 0) {
            this.setState({ loading: false })
            videoElem.play()
        }
        Promise.all([MediaAPI.getLiveStatus(), MediaAPI.getVOD()]).then(([status, vod]) => {
            this.props.onLoading(false)
            const streaming = status.status['supreme'] == 'Live'
            const streamUrl = streaming ? status.stream_url : status.placeholder_stream_url_mp4
            const currentVOD = (this.props.location.hash.replace('#', '') != '' && !streaming) ? vod.find(v => parseInt(v.id) == parseInt(this.props.location.hash.replace('#', ''))) : undefined

            if (streamUrl != this.lastSrc && !currentVOD) {
                this.initHLS(streamUrl, videoElem, streaming)
            }
            this.setState({ streaming, loading: false, vod, currentVOD, liveTitle: status.stream.title })
            if (!streaming) {
                videoElem.loop = true
                this.reloadTimer = setTimeout(() => {
                    this.load(false)
                }, 1000 * 60 * 30)
            } else {
                videoElem.loop = false
                videoElem.muted = false
                videoElem.addEventListener('ended', this.onVideoEnded)
            }
        }).catch(err => {
            this.props.onLoading(false)
            errorToString(err).forEach(error => {
                this.props.showToast('danger', error, () => {
                    this.load()
                })
            })
        })
        return videoElem
    }

    onResize() {
        this.resizeTimer && clearTimeout(this.resizeTimer)
        this.resetStyle()
        this.resizeTimer = setTimeout(() => {
            if (this.videoContainerDiv) {
                this.setStyle(this.videoContainerDiv)
            }
        }, 650)
    }

    private getAvailHeight() {
        if (this.props.maxHeight) {
            return this.props.maxHeight
        }
        return 850
    }


    public render() {
        if (this.state.loading) {
            return <></>
        }
        let renderFeaturedOrVOD = this.state.currentVOD ? this.state.currentVOD : (this.state.vod && !this.state.streaming ? this.state.vod.find(v => v.is_featured == true) : undefined)
        if (this.props.useLiveInline) {
            renderFeaturedOrVOD = undefined
        }
        return (<>
            {renderFeaturedOrVOD != undefined && this.renderFeaturedVod(renderFeaturedOrVOD)}
            {renderFeaturedOrVOD == undefined && <div className='video-split-view'>
                <div className="vid-container">
                    <div ref={(ref) => {
                        this.titleContainer = ref
                    }}>
                        <div className="video-title-container" >
                            <div className="video-title-small">BPM Live</div>
                            <div className="live-text">LIVE</div>
                        </div>
                        <div className="video-title">{this.state.liveTitle}</div>
                    </div>
                    <div className='video-chat-container'>
                        <div className='video-subtitle-container' ref={(ref) => {
                            if (ref) {
                                this.videoSubTitleContainer = ref
                            }
                        }}>
                            <div style={{ maxWidth: `${(this.getAvailHeight() - 70) * (16 / 9)}px` }}>
                                <div className="video-container" ref={(ref) => {
                                    if (ref) {
                                        this.videoContainerDiv = ref
                                        this.setStyle(ref)
                                    }
                                }}>
                                </div>
                            </div>
                            <div className="under-vid-container">
                                <div className="view-text-container">
                                    <img src={EYE_SVG} alt="eye" className="eye-svg" />
                                    <div className="view-text">{this.state.viewCount} views</div>
                                </div>
                                {/*<div className="share-container">
                                    <img src={SHARE_SVG} alt="share" className="share-icon" />
                                    <div className="share-text" onClick={() => shareLink(window.location.href)}>Share the stream</div>
                            </div>*/}
                            </div>
                        </div>
                        <Chat height={this.state.videoHeight} onViewerCountChange={this.onViewerCountChange} history={this.props.history} />
                    </div>
                </div>
            </div>}
            {this.props.useLiveInline !== true && <Box style={{ marginTop: 20 }}>
                {!this.state.vod && <Loader />}
                {this.state.vod && <h3>Videos</h3>}
                <div className='vod-container'>
                    {this.state.vod && this.state.vod.map(video => {
                        return <div className='vod' key={video.id}>
                            <div className='video-container'>
                                {this.renderVideoElement(video)}
                            </div>
                            <div className='vod-title-share'>
                                <div className='vod-title extra-info'>{video.name}</div>
                                <div className='vod-share'>
                                    <BrowseDropDown items={[{
                                        title: 'Copy Link', onClick: () => {
                                            this.copyVOD(video)
                                        }
                                    }]} />
                                </div>
                            </div>
                            <div className='vod-text-uploaded extra-info'>
                                {displayDate(video.created_at)}
                            </div>
                        </div>
                    })}
                </div>
            </Box>}
        </>
        )
    }

    renderFeaturedVod(vod: VOD) {
        return <>
            <h3>Featured</h3>
            <div className='featured-vod-container'>
                <div className='featured-vod' style={{ maxWidth: '70%' }}>
                    {vod.url.startsWith('https://www.youtube') &&
                        <YouTube
                            containerClassName='vod-youtube'
                            opts={{
                                playerVars: { autoplay: 1 },
                                height: `${(this.getAvailHeight() - 40 - 30)}px`,
                                width: `${(this.getAvailHeight() - 40 - 30) / 9 * 16}px`
                            }}
                            videoId={(vod.url.split('v=')[1] || '').split('&')[0]} onPlay={() => {
                                Analytics.trackClick('vod', vod.id)
                            }} />}
                    {!vod.url.startsWith('https://www.youtube') && <video className='vod-bpm' src={vod.url}
                        style={{ height: `${this.getAvailHeight() - 40 - 30 /* 30 for the h3 */}px`, maxWidth: '100%' }}
                        autoPlay controls ref={(ref) => {
                            if (!ref) {
                                return
                            }
                            if (!ref.canPlayType('application/vnd.apple.mpegurl') && vod.url.includes('.m3u8')) {
                                if (this.hls) {
                                    this.hls.destroy()
                                }
                                this.hls = new Hls();
                                this.hls.loadSource(vod.url);
                                this.hls.attachMedia(ref);
                                this.hls.on(Hls.Events.MANIFEST_PARSED, function () {
                                    ref.play();
                                });
                            }
                        }} onPlay={() => {
                            Analytics.trackClick('vod', vod.id)
                        }} />}
                </div>
                <div className='featured-vod-text-container'>
                    <div className='featured-vod-text-title extra-info'>
                        {vod.name}
                    </div>
                    <div className='featured-vod-text-description extra-info'>
                        {vod.description}
                    </div>
                    <div className='featured-vod-text-uploaded extra-info'>
                        {displayDate(vod.created_at)}
                    </div>
                    <div className='featured-vod-share'>
                        <BrowseDropDown items={[{
                            title: 'Copy Link', onClick: () => {
                                this.copyVOD(vod)
                            }
                        }]} />
                    </div>
                </div>
            </div>
        </>
    }

    copyVOD(vod: VOD) {
        shareVod(vod)
    }

    showVod(vod: VOD) {
        this.setState({ currentVOD: vod })
        this.resetStyle()
        this.props.history.replace('/bpmtv#' + vod.id)
    }

    renderVideoElement(vod: VOD) {
        if (vod.url.startsWith('https://www.youtube')) {
            return <img className='vod-youtube' src={`https://i.ytimg.com/vi/${(vod.url.split('v=')[1] || '').split('&')[0]}/sddefault.jpg`} onClick={() => {
                this.showVod(vod)
            }} />
        } else {
            if (vod.url.endsWith('m3u8')) {
                return <img className='vod-bpm' src={vod.url.split('/').slice(0, -1).join('/') + '/thumb.png'} onClick={() => {
                    this.showVod(vod)
                }} />
            }
            return <>
                <video className='vod-bpm' src={vod.url + '#t=4.1'} />
                <div className='vod-overlay' onClick={() => {
                    this.showVod(vod)
                }} />
            </>
        }
    }
}
LiveInner.contextType = UserContextType

const ChatList = autoscroll(class extends React.Component<{ messages: Message[], onScrolled: () => void }> {

    render() {
        const { messages, ...props } = this.props
        return (
            <UserContextConsumer>{user =>
                <div style={{ overflow: 'scroll', maxHeight: 'calc(100% - 110px)', marginTop: 20 }} {...props}>{
                    messages.map(message => {
                        return <div className={`chat-message ${message.from === user.username ? 'self' : ''}`} key={message.id}>
                            <div className='message-container'>
                                <div className="username">
                                    <span style={{ /*color: message.color,*/ marginRight: 8 }}>{message.from}</span>
                                    {
                                        message.admin ?
                                            <img className="admin-icon" src={VERIFIED_BLUE_SVG} alt="admin icon" />
                                            : null

                                    }
                                </div>
                                <div className='chat-message-text'>{message.message}</div>
                            </div>
                        </div>
                    })
                }</div>
            }</UserContextConsumer>
        )
    }
}, { isScrolledDownThreshold: 20 })

export const Live = withToast(withRouter(LiveInner))

function Chat(props: { height?: number, onViewerCountChange?: (viewerCount: number) => void, history: H.History }) {

    const [message, setMessage] = React.useState('');
    const [messages, setMessages] = React.useState<Message[]>([])
    const [viewerCount, setViewerCount] = React.useState(0)
    const [showEmojiPopup, setShowEmojiPopup] = React.useState(false);
    const socket = React.useRef<SocketIOClient.Socket>()

    React.useEffect(() => {
        props.onViewerCountChange &&
            props.onViewerCountChange(viewerCount)
    }, [viewerCount])

    React.useEffect(() => {
        socket.current = SocketIOClient('https://chat.bpmsupreme.com', { transports: ['websocket'], reconnectionAttempts: 3 });
        socket.current!.on('message', (args: { message?: Message, viewerCount: number, messages?: Message[] }) => {
            let messagesToAdd = args.message ? [args.message] : (args.messages ? args.messages : [])
            let viewerCount = args.viewerCount
            setMessages((messages) => {
                return messages.concat(messagesToAdd).unique('id')
            })
            setViewerCount(viewerCount)
        })
        return () => {
            socket.current && socket.current.disconnect()
        }
    }, [])

    return (<div className="chat-container" style={{
        height: `${props.height || 650}px`
    }}>
        <Row style={{
            flex: 1,
            overflow: 'hidden'
        }}>
            <Col className="list" style={{
                overflow: 'hidden',
                maxHeight: '100%'
            }}>
                <Row className="top-text-container">
                    <div className="above-title">Join the Conversation</div>
                    <div className="under-title">Click&nbsp;
                        <span className="here-text" onClick={() => props.history.push('/account')}>here</span> to change your username</div>
                </Row>
                <div className="divider"></div>
                <ChatList messages={messages} onScrolled={() => { }} />
            </Col>
        </Row>
        <Row className="message-box">
            <Col>
                <div className={`pick-emoji-window ${showEmojiPopup ? '' : 'hide'}`}>
                    <Picker onEmojiClick={(event: Event, emojiObject: any) => {
                        setMessage((message) => message + emojiObject.emoji)
                        const input = document.querySelector('.chat-message-input') as HTMLElement
                        input.focus()
                        setShowEmojiPopup(false)
                    }} />
                </div>
                <div className="click-emoji-icon" onClick={() => {
                    setShowEmojiPopup(!showEmojiPopup)
                }}>🙂</div>
                <Input
                    type="text"
                    className='chat-message-input'
                    style={{
                        resize: 'none'
                    }}
                    placeholder={'Send a message'}
                    value={message || ''}
                    onKeyUp={e => {
                        if (e.key === "Enter") {
                            if (socket.current && message.trim() != '') {
                                socket.current.send({
                                    message: message,
                                    time: new Date()
                                });
                            }
                            setMessage('')
                            e.preventDefault()
                            e.stopPropagation()
                        }
                    }}
                    onChange={val => {
                        setMessage(val.target.value)
                    }}
                />
                <div className="chat-send-btn" onClick={(e) => {
                    if (socket.current && message.trim() != '') {
                        socket.current.send({
                            message: message,
                            time: new Date()
                        });
                    }
                    setMessage('')
                    e.preventDefault()
                    e.stopPropagation()
                }}>
                    <img className="chat-send-icon" src={SHARE_SVG} alt="" />
                </div>
                <i className="far fa-meh-blank"></i>
            </Col>
        </Row>
        <Row style={{
            alignItems: 'center',
            marginTop: 20,
            display: 'none'
        }}>
            <Col>
                <img src={PROFILE_PICTURE_RED} width={24} />
                <span style={{
                    marginLeft: 8
                }} className='chat-message-text'>{viewerCount || 0}</span>
            </Col>
        </Row>
    </div>);
}



// WEBPACK FOOTER //
// ./src/pages/Live.tsx